// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"449a1deb","644":"e5984959","767":"8652cdc8","799":"25915e36","952":"ae1cfe1c"}[chunkId] + ".chunk.css";
};